import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import { Loader2, Search } from "lucide-react";

export default function AgentClients() {
  const { t } = useContent();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get("/agent/clients", { params: q ? { search: q } : {} }).then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [q]);
  if (rows === null) return <div className="py-20 text-center"><Loader2 className="mx-auto h-7 w-7 animate-spin text-accent" /></div>;
  return (
    <div data-testid="agent-clients">
      <h1 className="font-display text-2xl font-bold">{t("agent.clients.title", "Clients")}</h1>
      <div className="mt-4 flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-900 px-3 py-2">
        <Search className="h-4 w-4 text-slate-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("agent.clients.search", "Rechercher par nom ou email")} data-testid="client-search" className="w-full bg-transparent text-sm outline-none placeholder:text-slate-500" />
      </div>
      <div className="mt-4 overflow-x-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-slate-800 text-xs uppercase text-slate-500">
            <tr><th className="px-3 py-2.5">{t("agent.clients.col.name", "Nom")}</th><th className="px-3 py-2.5">{t("agent.clients.col.email", "Email")}</th><th className="px-3 py-2.5">{t("agent.clients.col.status", "Statut")}</th><th className="px-3 py-2.5">{t("agent.clients.col.balance", "Solde")}</th><th className="px-3 py-2.5">{t("agent.clients.col.orders", "Commandes")}</th></tr>
          </thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.id} className="border-b border-slate-800/60" data-testid={`client-row-${u.id}`}>
                <td className="px-3 py-2.5 font-medium text-white">{u.name}</td>
                <td className="px-3 py-2.5 text-slate-400">{u.email}</td>
                <td className="px-3 py-2.5 text-xs text-slate-400">{u.status}</td>
                <td className="px-3 py-2.5 text-slate-300">{u.balance === null ? <span className="text-slate-600">{t("agent.clients.hidden", "masqué")}</span> : `$${Number(u.balance).toFixed(2)}`}</td>
                <td className="px-3 py-2.5 text-slate-400">{u.orders_count}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={5} className="px-3 py-10 text-center text-slate-500">{t("agent.clients.empty", "Aucun client.")}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
